<template>
  <div id="app" :class="isLangEn ? 'app-layout-type-en' : 'app-layout-type-zh'">
    <router-view />
    <GlobalLayer />
  </div>
</template>

<script>
import GlobalLayer from '@/components/globalLayer'

import { mapMutations, mapState } from 'vuex'
// import home from './locales/lang/zh-CN/home'

// import utils from '@/utils'

export default {
  name: 'app',
  components: {
    GlobalLayer
  },
  methods: {
    ...mapMutations({
      setMoblie: 'CHECK_MOBILE'
    }),
    checkMobile () {
      const ua = navigator.userAgent.toLowerCase()
      return (/iphone|android|ucweb|ucbrowser|nokia|sony|ericsson|mot|samsung|sgh|lg|philips|panasonic|alcatel|lenovo|cldc|midp|wap|mobile/i.test(ua) && !/ipad/i.test(ua)) || document.body.clientWidth <= 768
    },
    // // 微信分享
    // initWxConfig () {
    //   let data = this.data['微信分享']
    //   const ua = window.navigator.userAgent
    //   if (!ua.match(/MicroMessenger/i)) return
    //   let url = window.location.href
    //   axios.get(`https://misc.geekbang.org/wxmisc/wxshare/sign?url=${encodeURIComponent(url)}&mpid=gh_a4dbefba05a2`)
    //   .then(res => {
    //     if (res.data.code === 0) {
    //       if (!window.wx) return
    //       window.wx.config({
    //         debug: false,
    //         appId: res.data.data.appId,
    //         timestamp: res.data.data.timestamp,
    //         nonceStr: res.data.data.nonceStr,
    //         signature: res.data.data.signature,
    //         jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
    //       })
    //     }
    //   }).catch(res => {
    //   })
    //   window.wx.ready(function () {
    //     window.wx.onMenuShareTimeline({
    //       title: data['标题'],
    //       imgUrl: data['图片'],
    //       link: window.location.href,
    //       success: function () {},
    //       cancel: function () {}
    //     })
    //     window.wx.onMenuShareAppMessage({
    //       title: data['标题'],
    //       desc: data['介绍'],
    //       imgUrl: data['图片'],
    //       link: window.location.href,
    //       type: 'link',
    //       dataUrl: '',
    //       success: () => {},
    //       cancel: () => {}
    //     })
    //   })
    // }
  },
  computed: {
    ...mapState(['lang', 'isEnLang']),
    isLangEn () {
      return this.lang === 'en-US'
    }
  },
  mounted () {
    // window.onresize = function () {
    //   this.setMoblie(this.checkMobile())
    // }.bind(this)

    // console.log(this.checkMobile())

    // window.addEventListener('resize', () => {
    //   this.setMoblie(this.checkMobile())
    // })

    // console.log(this)
  },
  created () {
    this.setMoblie(this.checkMobile())

    // utils.GA('create')

    document.title = 'FinTechathon | 深圳国际金融科技大赛'
  },
  watch: {
    isEnLang (val) {
      if (val) {
        document.title = 'FinTechathon 2026 | Shenzhen International FinTech Competition'
      } else {
        document.title = 'FinTechathon | 深圳国际金融科技大赛'
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/css/_reset.scss';
@import '~@/assets/css/_base.scss';
@import '~@/assets/css/custom.modal';
@import '~@/assets/css/custom.popup';
@import '~@/assets/css/design-v2';
@import '~@/assets/css/design-v1-refresh';

/* English copy is materially longer than the Chinese source. These rules keep
   the bilingual site visually consistent without changing the Chinese layout. */
.app-layout-type-en {
  overflow-x: clip;

  .theme-v1-color-roadmap .nav-pc {
    .logo { width: 272px !important; }
    .logo-img { width: 252px !important; }
    .nav-li { margin-right: 22px !important; }
    .button--international {
      width: 300px !important;
      min-width: 300px !important;
      flex-basis: 300px !important;
      padding: 0 18px !important;
      font-size: 11px !important;
      line-height: 1.25 !important;
    }
  }

  .introduction .left {
    hyphens: auto;
    text-align: left !important;
    overflow-wrap: anywhere;
  }

  .note {
    .region-option strong,
    .track-name,
    .intro-title,
    .ai-scenario strong,
    .direction-card strong { hyphens: auto; }
  }

  .schedule .portrait-event > div {
    hyphens: auto;
  }

  .judges .content-text-title,
  .partner .c-content {
    hyphens: auto;
    overflow-wrap: anywhere;
  }

  .rule {
    .track-option strong,
    .flow-heading h3,
    .step strong,
    .step p,
    .criterion h4,
    .criterion p { hyphens: auto; }
  }
}

/* The Chinese edition uses shorter copy, but still needs dedicated narrow-screen
   geometry so navigation, timelines and dense information cards remain legible. */
.app-layout-type-zh {
  overflow-x: clip;
}

@media (max-width: 1180px) {
  .app-layout-type-en {
    .partner .container {
      width: calc(100vw - 40px) !important;
      max-width: none;
      box-sizing: border-box;
    }
    .partner .content {
      width: 100% !important;
      margin-left: 0 !important;
    }
    .partner .container { padding-right: 36px; padding-left: 36px; }
    .partner .c-content-wrap--technical { display: flex; }
    .partner .c-content-wrap--technical .c-content { white-space: normal; }
  }
}

@media (max-width: 768px) {
  .app-layout-type-zh {
    .theme-v1-color-roadmap .section { padding-top: 48px; padding-bottom: 48px; }

    .introduction .content-bg { padding: 22px 18px !important; }
    .introduction .left {
      font-size: 14px !important;
      line-height: 1.9 !important;
      text-align: left !important;
    }

    .note .layout-content { width: calc(100vw - 28px) !important; max-width: none; }
    .note .region-switch { width: 100%; }
    .note .region-option { min-width: 0; }
    .note .block { padding: 22px 17px 20px !important; }
    .note .ai-scenario,
    .note .direction-card { min-height: 0; }
    .note .ai-scenario p,
    .note .direction-card p {
      display: block;
      overflow: visible;
      -webkit-line-clamp: initial;
    }
    .note .block-btn-default {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: 40px;
      height: auto;
      margin: 0;
      padding: 8px 14px;
      line-height: 1.3;
    }

    .schedule .region-panel { overflow: hidden; }
    .schedule .vertical-timeline { width: 100% !important; }
    .schedule .portrait-event { width: 100% !important; }
    .schedule .portrait-event > div {
      width: calc(50% - 30px) !important;
      max-width: calc(50% - 30px) !important;
    }
    .schedule .portrait-event.copy-left > div { right: calc(50% + 26px) !important; }
    .schedule .portrait-event.copy-right > div { left: calc(50% + 26px) !important; }
    .schedule .portrait-event small { line-height: 1.4 !important; }

    .prize .awards-section { padding-right: 17px; padding-left: 17px; }
    .prize .prize-pool { padding-right: 12px; padding-left: 12px; }

    .partner .container { padding: 34px 0 !important; }
    .partner .content { width: 100% !important; }
    .partner .c-content-wrap { display: block; }
    .partner .c-content {
      margin-bottom: 9px;
      font-size: 13px;
      line-height: 1.65;
      white-space: normal !important;
      overflow-wrap: anywhere;
    }
  }

  .app-layout-type-en {
    .theme-v1-color-roadmap .banner { margin-top: 94px; }
    .theme-v1-color-roadmap .section { padding-top: 52px; padding-bottom: 52px; }

    .introduction .content-bg { padding: 22px 18px !important; }
    .introduction .left {
      font-size: 13.5px !important;
      line-height: 1.82 !important;
    }
    .introduction .left p { margin-bottom: 16px; }

    .note .layout-content { width: calc(100vw - 28px) !important; }
    .note .region-switch { width: 100%; }
    .note .region-option { min-width: 0; }
    .note .region-option strong { font-size: 13px; line-height: 1.25; }
    .note .block { padding: 22px 17px 20px !important; }
    .note .tab-box {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 4px;
    }
    .note .btn-tab {
      height: auto;
      min-height: 42px;
      padding: 7px 8px;
      line-height: 1.3;
    }
    .note .ai-scenario,
    .note .direction-card { min-height: 0; }
    .note .ai-scenario p,
    .note .direction-card p {
      display: block;
      overflow: visible;
      -webkit-line-clamp: initial;
    }
    .note .block-btn-default {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: auto;
      min-height: 40px;
      margin: 0;
      padding: 8px 14px;
      line-height: 1.3;
    }

    .schedule .region-panel { overflow: hidden; }
    .schedule .vertical-timeline { width: 100% !important; }
    .schedule .portrait-event { width: 100% !important; }
    .schedule .portrait-event > div {
      width: calc(50% - 30px) !important;
      max-width: calc(50% - 30px) !important;
    }
    .schedule .portrait-event.copy-left > div { right: calc(50% + 26px) !important; }
    .schedule .portrait-event.copy-right > div { left: calc(50% + 26px) !important; }
    .schedule .portrait-event small { line-height: 1.35 !important; }

    .prize .awards-section { padding: 26px 17px 22px; }
    .prize .prize-pool {
      min-height: 0;
      padding: 28px 12px;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      text-align: center;
    }
    .prize .prize-pool > span { margin-bottom: 8px; font-size: 13px; }
    .prize .prize-pool div { justify-content: center; }
    .prize .prize-pool strong { font-size: clamp(46px, 16vw, 64px); }
    .prize .prize-pool b { font-size: 16px; }
    .prize .prize-pool small { margin-top: 8px; font-size: 13px; }
    .prize .award-heading span { line-height: 1.3; }
    .prize .award-rank { font-size: 15px; text-align: center; }
    .prize .award-amount { font-size: 21px; }

    .judges .content { grid-template-columns: 1fr !important; }
    .judges .content-item {
      display: grid;
      grid-template-columns: minmax(118px, 38%) minmax(0, 1fr);
      align-items: stretch;
    }
    .judges .content-img-wrap { height: 100%; min-height: 150px; aspect-ratio: auto; }
    .judges .content-text { align-self: center; }

    .partner .container { padding: 36px 0 !important; }
    .partner .content { width: 100% !important; }
    .partner .c-content-wrap { display: block; }
    .partner .c-content { margin-bottom: 9px; line-height: 1.55; }

    .rule { padding-top: 94px !important; }
    .rule .track-entry { padding: 34px 0 26px; }
    .rule .track-switch { align-items: stretch; }
    .rule .track-option { min-height: 58px; }
    .rule .track-option strong { font-size: 13px; line-height: 1.25; }
    .rule .process-grid--split,
    .rule .review-grid--split { gap: 14px; }
    .rule .track-flow,
    .rule .review-panel { padding-right: 18px; padding-left: 18px; }
    .rule .criterion { grid-template-columns: 54px minmax(0, 1fr); gap: 12px; }
    .rule .contact-line a { font-size: 16px; }
  }
}

@media (max-width: 600px) {
  .app-layout-type-zh {
    .theme-v1-color-roadmap .banner { margin-top: 94px !important; }

    .judges .content { grid-template-columns: 1fr !important; gap: 14px; }
    .judges .content-item {
      display: grid;
      grid-template-columns: 116px minmax(0, 1fr);
      align-items: stretch;
    }
    .judges .content-img-wrap {
      width: 116px;
      height: 100%;
      min-height: 146px;
      aspect-ratio: auto;
    }
    .judges .content-text {
      align-self: center;
      padding: 14px 13px;
    }
    .judges .content-text-title { font-size: 12px; line-height: 1.65; }

    .rule { padding-top: 94px !important; }
    .rule .track-entry { padding-top: 34px; }
  }
}

@media (max-width: 390px) {
  .app-layout-type-zh {
    .note .region-option { padding-right: 7px; padding-left: 7px; }
    .note .region-option strong { font-size: 13px; }
    .schedule .region-panel { padding-right: 10px; padding-left: 10px; }
    .schedule .portrait-event > div {
      width: calc(50% - 26px) !important;
      max-width: calc(50% - 26px) !important;
    }
    .schedule .portrait-event.copy-left > div { right: calc(50% + 22px) !important; }
    .schedule .portrait-event.copy-right > div { left: calc(50% + 22px) !important; }
    .schedule .portrait-event strong { font-size: 14px !important; }
    .schedule .portrait-event small { font-size: 9px !important; }
  }

  .app-layout-type-en {
    .note .region-option { padding: 8px 6px; }
    .note .region-option strong { font-size: 12px; }
    .schedule .region-panel { padding-right: 10px; padding-left: 10px; }
    .schedule .portrait-event > div {
      width: calc(50% - 26px) !important;
      max-width: calc(50% - 26px) !important;
    }
    .schedule .portrait-event.copy-left > div { right: calc(50% + 22px) !important; }
    .schedule .portrait-event.copy-right > div { left: calc(50% + 22px) !important; }
    .schedule .portrait-event strong { font-size: 14px !important; }
    .schedule .portrait-event small { font-size: 8.5px !important; }
    .prize .awards-grid { grid-template-columns: 1fr; }
    .prize .award-card { min-height: 104px; }
    .judges .content-item { grid-template-columns: 116px minmax(0, 1fr); }
    .judges .content-text { padding: 14px 12px; }
  }
}

// 上下间距
.section {
  padding-top: $sectionGap;
  padding-bottom: $sectionGap;

  @include mobile {
    padding-top: $sectionGapMoible;
    padding-bottom: $sectionGapMoible;
  }
}

// section 背景色
// .section-settings {
//   background: $black;
//   color: #fff;
// }

.interline-shu {
  $blue: #2B70FB;
  width: 1px;
  border-radius: 1px;;
  background: linear-gradient(to bottom, transparent , $blue 5%, $blue 95%, transparent);;
}
</style>
